import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { FaqPublicViewComponent } from './faqPublicView.component';
import { CalculadoraPublicComponent } from './calculadoraPublic.component';
import { AuthComponent } from './auth.component';

export const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'faqs-public',
        component: FaqPublicViewComponent,
      },
      {
        path: 'calculadora-public',
        component: CalculadoraPublicComponent,
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class AuthRoutingModule {
}

export const routedComponents = [
  LoginComponent,
  FaqPublicViewComponent,
  CalculadoraPublicComponent,
  AuthComponent
];